export default __webpack_public_path__ + "static/media/IconDetail.569155cc.svg";